import { AppEnv } from './env-types';
import { merge } from 'lodash';
import { envDefaults } from './env-defaults';

window.MLBBest = {
  env: merge(envDefaults, {
    appEnv: AppEnv.PROD,
    piaApiBaseUrl: 'https://pia.best-gcp.mlbinfra.com',
    oidc: {
      issuer: 'https://mlb.okta.com/oauth2/ausrs7ahr7PCsEYWk0x7',
      clientId: '0oa1b22hea6chFZUT0x8',
    },
  }),
};
